export const stylesFolders = {
  height: 'calc(100vh - 120px)',
  display: 'flex',
  flexDirection: 'column',
};

export const stylesFoldersPaper = {
  height: '100%',
  overflow: 'auto',
};

export const stylesFoldersTableHeader = {
  '.MuiTableCell-head': {
    py: 3,
    px: 2,
  },
};
